import { clearUserData, USER_DATA_UPDATED_EVENT } from "./userStorage";
import { unregisterFcmToken } from "../services/firebaseMessaging";

export const SESSION_EXPIRED_EVENT = "session-expired";

const SESSION_STORAGE_KEYS = [
	"jwt_token",
	"user_data",
	"login_count",
	"type_transaction_value",
	"warehouse.name",
];

let isHandlingSessionExpiry = false;

export function clearSessionStorage() {
	SESSION_STORAGE_KEYS.forEach((key) => {
		localStorage.removeItem(key);
	});
	clearUserData();
}

/**
 * Clears auth data and sends the user to login. Safe to call from HTTP interceptors
 * (deduped so parallel 401s only redirect once).
 */
export function handleSessionExpired({ redirect = true } = {}) {
	if (isHandlingSessionExpiry) return;
	isHandlingSessionExpiry = true;

	clearSessionStorage();

	window.dispatchEvent(
		new CustomEvent(SESSION_EXPIRED_EVENT, { detail: {} }),
	);
	window.dispatchEvent(
		new CustomEvent(USER_DATA_UPDATED_EVENT, { detail: {} }),
	);

	if (!redirect) {
		isHandlingSessionExpiry = false;
		return;
	}

	const loginPath = "/";
	if (window.location.pathname !== loginPath) {
		window.location.replace(loginPath);
		return;
	}

	isHandlingSessionExpiry = false;
}

export async function logoutSession({ redirect = true } = {}) {
	isHandlingSessionExpiry = false;
	try {
		await unregisterFcmToken();
	} catch (_) {
		// best-effort
	}
	handleSessionExpired({ redirect });
}

export function getBearerToken() {
	try {
		const raw = localStorage.getItem("jwt_token");
		if (!raw || raw === "null") return null;
		return JSON.parse(raw);
	} catch {
		return null;
	}
}

export function attachAuthInterceptor(client) {
	client.interceptors.request.use((config) => {
		const token = getBearerToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});

	client.interceptors.response.use(
		(response) => {
			if (response?.status === 401) {
				handleSessionExpired();
			}
			return response;
		},
		(error) => {
			if (error?.response?.status === 401) {
				handleSessionExpired();
			}
			return Promise.reject(error);
		},
	);
}
